import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Helmet } from "react-helmet";

export const DefaultSEO = () => {
  const data = useStaticQuery(graphql`
    {
      prismicSettings {
        data {
          seo_title
          seo_description
          seo_image {
            url
          }
        }
      }
    }
  `);

  return (
    <Helmet
      htmlAttributes={{ lang: "en" }}
      title={`${data.prismicSettings.data.seo_title}`}
      meta={[
        {
          name: "robots",
          content: `max-image-preview:large`,
        },
        {
          name: "description",
          content: `${data.prismicSettings.data.seo_description}`,
        },
        {
          name: "og:site_name",
          content: `${data.prismicSettings.data.seo_title}`,
        },
        {
          name: "og:title",
          content: `${data.prismicSettings.data.seo_title}`,
        },
        {
          name: "og:image",
          content: `${data.prismicSettings.data.seo_image.url}`,
        },
        {
          name: "og:image:secure_url",
          content: `${data.prismicSettings.data.seo_image.url}`,
        },
        {
          name: "og:description",
          content: `${data.prismicSettings.data.seo_description}`,
        },
        {
          name: "og:image:width",
          content: `1200`,
        },
        {
          name: "og:image:height",
          content: `630`,
        },
        {
          name: "og:locale",
          content: `en_EN`,
        },
        {
          name: "og:type",
          content: `website`,
        },
        {
          name: "twitter:title",
          content: `${data.prismicSettings.data.seo_title}`,
        },
        {
          name: "twitter:description",
          content: `${data.prismicSettings.data.seo_description}`,
        },
        {
          name: "twitter:card",
          content: `summary_large_image`,
        },
        {
          name: "twitter:image",
          content: `${data.prismicSettings.data.seo_image.url}`,
        },
      ]}
      link={[
        {
          rel: "preload",
          href: "/fonts/fonts.css",
          as: "style",
        },
        {
          rel: "dns-prefetch",
          href: "https://images.prismic.io/lcs-studio",
        },
        {
          rel: "preconnect",
          href: "https://images.prismic.io/lcs-studio",
        },
        {
          rel: "dns-prefetch",
          href: "https://player.vimeo.com",
        },
        {
          rel: "preconnect",
          href: "https://player.vimeo.com",
        },
        {
          rel: "preconnect",
          href: "https://i.vimeocdn.com",
        },
        {
          rel: "preconnect",
          href: "https://f.vimeocdn.com",
        },
      ]}
    />
  );
};
